import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { BasicFormStoreProvider } from 'stores/local';

export const FormCreationRoutes: React.FC = () => {
  return (
    <BasicFormStoreProvider>
      <Outlet />
    </BasicFormStoreProvider>
  );
};
